import {cn} from '@tempmee/core'
import {type HTMLAttributes, forwardRef} from 'react'
import {TableSectionContext} from './context'

export interface TableHeadProps extends HTMLAttributes<HTMLTableSectionElement> {}

/**
 * TableHead (v3, MUI-aligned) — renders `<thead>` and marks its cells as header
 * cells. Mirrors `@mui/material/TableHead`: any `TableCell` inside defaults to
 * `variant="head"` (a bold `<th scope="col">`).
 */
export const TableHead = forwardRef<HTMLTableSectionElement, TableHeadProps>(
  ({className, ...props}, ref) => (
    <TableSectionContext.Provider value="head">
      <thead ref={ref} className={cn(className)} {...props} />
    </TableSectionContext.Provider>
  ),
)
TableHead.displayName = 'TableHead'
